var _ellipse, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSesionesEnVivo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 63,
    viewBox: "0 0 90 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.5828,
    cy: 30.9809,
    rx: 13.3748,
    ry: 15.604,
    fill: "#9B5AE6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8331 2.00122C11.511 5.6562 2 14.5326 2 33.3296C2 45.9235 12.6999 59.9588 19.8331 59.9588",
    stroke: "#9B5AE6",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2919 15.377C22.2114 17.345 17.6045 20.8594 17.6045 30.9809C17.6045 37.7622 22.5086 46.5849 24.2919 46.5849",
    stroke: "#9B5AE6",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3822 60.5283C78.5758 56.5936 87.7807 47.4001 87.144 28.6139C86.7175 16.0272 75.5484 2.3624 68.4193 2.60399",
    stroke: "#9B5AE6",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4732 47.3108C67.4858 45.2734 71.9711 41.605 71.6283 31.4893C71.3986 24.7119 66.1985 16.0604 64.4162 16.1208",
    stroke: "#9B5AE6",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSesionesEnVivo);
export default __webpack_public_path__ + "static/media/sesiones_en_vivo.29e125cdaeb7a56b19457d8a33ead386.svg";
export { ForwardRef as ReactComponent };